var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHuahua(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.6659721%",
    y1: "0%",
    x2: "92.067526%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.6846526%",
    y1: "0%",
    x2: "76.00513%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "4.71800443%",
    x2: "92.2525491%",
    y2: "95.2819956%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "4.71800443%",
    x2: "92.2525491%",
    y2: "95.2819956%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.0666102%",
    y1: "100%",
    x2: "10.6668285%",
    y2: "1.35308431e-14%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.6668285%",
    y1: "0%",
    x2: "92.0666102%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003351",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081F2B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.6668285%",
    y1: "0%",
    x2: "92.0666102%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0.208762906%",
    x2: "92.2525491%",
    y2: "99.7912371%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "7.5611146%",
    x2: "92.2525491%",
    y2: "92.4388854%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.6286039%",
    y1: "100%",
    x2: "35.3869243%",
    y2: "1.35308431e-14%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.6668285%",
    y1: "0%",
    x2: "92.0666102%",
    y2: "100%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-36.000000, -247.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(37.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chihuahua_logo_w_text",
    transform: "translate(10.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "faccia_cane"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54,26.9955683 C54,42.2502369 40.5507978,52.2814803 30.334305,53.8022243 C29.3258504,53.9533542 28.5812905,53.981691 28.2796966,53.9911367 C17.1395726,54.3406244 0.118362228,44.3377179 0.118362228,26.9955683 C0.10894295,12.4115384 12.1444239,0 27.0544715,0 C41.9362447,0 54,12.0903875 54,26.9955683 Z",
    id: "Path",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0853789,11.5330962 C34.3209991,12.175398 35.0090102,12.420984 35.5179498,12.8082543 C39.3349974,15.7741774 42.1907145,19.3540656 44.1322251,23.5573644 C44.6223152,24.6247189 44.8485106,25.777084 45.4516984,26.806656 C45.4611232,26.7972104 45.4799728,26.7877648 45.4893976,26.7877648 C45.5082472,26.7783192 45.5082472,26.7688736 45.5082472,26.7594279 C45.5647961,26.683863 49.6928624,22.9056169 52.0113653,17.8427672 C52.4920306,16.7943039 53.4627859,14.631258 53.802079,11.6653348 C54.2827443,7.48092726 53.0103951,6.12075867 53.1234928,3.06982495 C53.1329176,2.90924949 53.1517672,2.50308804 52.8972974,2.15360027 C52.322384,1.34127736 50.7672906,1.49240721 49.5232158,1.70021074 C45.7909915,2.33306696 42.1718649,2.94703195 38.4867646,6.08297621 C37.3086635,7.09365704 35.5650739,8.84109586 34.0853789,11.5330962 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8256431,12.0903875 C19.5900229,12.7326893 18.9020118,12.9782753 18.3930721,13.3655456 C14.5760245,16.3314687 11.7203075,19.9113569 9.77879684,24.1146557 C9.28870678,25.1820102 9.06251137,26.3343753 8.4593236,27.3639473 C8.44989879,27.3545017 8.43104917,27.3450561 8.42162436,27.3450561 C8.40277475,27.3356105 8.40277475,27.3261649 8.40277475,27.3167192 C8.34622589,27.2411543 4.21815961,23.4629082 1.89965663,18.4000585 C1.41899138,17.3515952 0.448236069,15.1885493 0.10894295,12.2226261 C-0.371722302,8.03821856 0.900626894,6.67804997 0.787529188,3.62711625 C0.778104379,3.46654079 0.759254761,3.06037933 1.0137246,2.71089157 C1.58863794,1.89856866 3.1437314,2.0496985 4.38780617,2.25750204 C8.12003048,2.89035826 11.7391571,3.50432325 15.4242573,6.64026751 C16.6023585,7.66039395 18.3553729,9.39838715 19.8256431,12.0903875 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9868351,13.3088719 C18.7983389,13.8567175 18.2611248,14.0645211 17.8652828,14.3951176 C14.8587688,16.9170969 12.6062395,19.9680306 11.0794205,23.5479188 C10.6930033,24.4546978 10.5139319,25.4370418 10.0426915,26.315484 C10.0238419,26.3060384 9.99556744,26.2871472 9.99556744,26.2777016 C9.79764646,24.7475119 8.91171442,23.5857012 8.01635758,22.3672169 C6.17851985,19.8641288 5.35856148,16.9265425 4.76479853,13.9417281 C4.24643404,11.3536295 4.06736267,8.73719409 4.00138901,6.10186744 C3.98253939,5.26120768 4.2087348,5.09118661 5.03811798,5.26120768 C10.60818,6.41357274 15.2640356,9.08668185 18.9868351,13.3088719 Z",
    id: "Path",
    fill: "#052638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2813593,12.9404929 C36.4604307,13.4883385 37.0070696,13.6961421 37.4029116,14.0361842 C40.390576,16.5770547 42.6242557,19.6374341 44.1322251,23.2267679 C44.5186423,24.1429925 44.6882888,25.1158909 45.1501045,25.9943331 C45.1689541,25.9848875 45.1972285,25.9659963 45.1972285,25.9565507 C45.4045743,24.426361 46.2905064,23.2739959 47.195288,22.0555116 C49.0425505,19.5618691 49.8813585,16.6337284 50.4939711,13.648914 C51.0311852,11.070261 51.2291062,8.44438002 51.3045047,5.81849898 C51.3327791,4.97783923 51.1065837,4.79837254 50.2677757,4.96839361 C44.6977137,6.09242182 40.0324333,8.73719409 36.2813593,12.9404929 Z",
    id: "Path",
    fill: "#052638"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "url(#linearGradient-5)",
    strokeWidth: 0.5,
    fillOpacity: 0.1,
    fill: "url(#linearGradient-4)",
    cx: 27.4785879,
    cy: 26.1737998,
    rx: 19.0569635,
    ry: 18.1355812
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-6)",
    cx: 17.0641741,
    cy: 29.5364388,
    rx: 6.75758795,
    ry: 6.77250612
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-7)",
    cx: 17.2243958,
    cy: 29.0547124,
    rx: 5.35329143,
    ry: 5.36510945
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-6)",
    cx: 41.0126134,
    cy: 29.1869511,
    rx: 6.75758795,
    ry: 6.77250612
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-7)",
    cx: 41.1728351,
    cy: 28.7052247,
    rx: 5.35329143,
    ry: 5.36510945
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-8)",
    cx: 42.5959813,
    cy: 26.192691,
    rx: 1.60221751,
    ry: 1.60575459
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-9)",
    transform: "translate(37.903777, 32.795243) rotate(-80.781636) translate(-37.903777, -32.795243) ",
    cx: 37.903777,
    cy: 32.7952431,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5926558,45.5184198 C26.9413738,46.1040479 28.0535012,47.9648341 30.0704103,47.9648341 C31.5124061,47.9648341 32.8790033,46.9919358 33.53874,45.5278654 C33.6801121,45.0366934 34.1136533,43.3931564 33.2654205,42.1274439 C31.7103271,39.8132682 26.8942497,40.2288753 25.9234944,42.1841176 C25.3108818,43.402602 26.3004868,45.0366934 26.5926558,45.5184198 Z",
    id: "Path",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5725582,38.7648049 C37.874152,40.6350367 37.139017,42.5619422 35.8666678,43.8182091 C34.8393636,44.8383355 33.7083865,45.168932 32.7282064,45.4428549 C31.861124,45.6884409 27.4597383,46.9163708 24.0573823,44.2243705 C23.5484426,43.8276547 21.409011,42.1274439 21.3053381,39.5298997 C21.2487892,38.1319487 21.8142778,37.0457029 22.1629957,36.3750643 C23.3882208,34.0703341 24.7736677,34.0608885 25.9140696,32.5779269 C28.6378394,29.0263756 25.8386711,22.3766625 27.61996,19.9302481 C27.7801818,19.7035534 28.2419974,19.0801428 28.8734596,19.0705842 C29.4860722,19.0612515 29.9573126,19.6468797 30.1269592,19.8546832 C32.0496202,22.2444239 29.9290382,29.1586142 33.0203755,32.6157094 C33.9628564,33.6736183 35.1692319,34.1553447 36.4698555,36.23338 C36.9787952,37.0268117 37.4029116,37.7352328 37.5725582,38.7648049 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5897451,40.3800051 C28.7132378,40.1816472 27.9969524,39.6999208 27.9498283,39.6621384 C27.3183661,39.2370857 26.5549566,38.7175768 26.6115055,38.075275 C26.6397799,37.7635697 26.8471257,37.5274293 26.8942497,37.4802012 C27.1298699,37.2346152 27.4503134,37.1496047 27.9969524,37.0173661 C28.0723508,36.9984749 28.1760237,36.970138 28.3173959,36.9512468 C29.7028428,36.6962152 31.220237,36.8756819 31.220237,36.8756819 C31.5218309,36.9134643 31.8422744,36.9606924 32.1815675,37.0362573 C32.4454621,37.092931 32.699932,37.1590503 32.9261274,37.2251696 C33.1994469,37.2912889 33.4162175,37.4802012 33.4916159,37.7352328 C33.5764392,38.0280469 33.4350671,38.2736329 33.4162175,38.320861 C33.0674995,38.9537172 32.6622327,39.3787699 32.3794885,39.6243559 C32.0401954,39.9266156 31.6443534,40.2761033 31.0505904,40.408342 C30.6830229,40.4933525 30.3154553,40.4744613 30.2306321,40.4744613 C30.136384,40.4650156 29.9007638,40.4461244 29.5897451,40.3800051 Z",
    id: "Path",
    fill: "#042A40"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-8)",
    cx: 18.6381172,
    cy: 26.5421788,
    rx: 1.60221751,
    ry: 1.60575459
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-12)",
    cx: 14.3397743,
    cy: 33.1446638,
    rx: 1,
    ry: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M14.7653759,14.6848674 L14.7653759,13 L13,13 L13,21 L14.7653759,21 L14.7653759,17.6926677 C14.7653759,16.4945398 16.428246,15.1466459 17.8063781,15.1466459 L18,15.1466459 L18,13.2121685 L17.8063781,13.2121685 C16.5990888,13.2121685 15.3120729,13.7113885 14.7653759,14.6848674 Z",
    id: "Path",
    fill: "#081E2B",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuahua);
export default __webpack_public_path__ + "static/media/huahua.c3afee12d38bc278782226b1879bef0f.svg";
export { ForwardRef as ReactComponent };